<template>
    <div class="mobile-navigation" :class="{ 'open': isMobileNavigationOpen }"> 
        <div class="nav-header d-flex">
            <div class="btn-close d-flex" @click="closeNavigation()">
                <svg xmlns="http://www.w3.org/2000/svg" width="18.286" height="19.232" viewBox="0 0 18.286 19.232">
                    <g id="Icon" transform="translate(1.143 1.616)">
                        <rect id="Area" width="16" height="16" transform="translate(0.001 0)" fill="#fcfcfc" opacity="0"/>
                        <g id="Icon-2" data-name="Icon">
                        <line id="dc5b8dca-93dc-4323-8a91-2653592a474c" x1="16" transform="translate(0 8)" fill="none" stroke="#697578" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.286"/>
                        <path id="ca26a024-ae3a-4c86-903b-83a925234c9f" d="M13.714,21.714l-8-8,8-8" transform="translate(-5.714 -5.714)" fill="none" stroke="#697578" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.286"/>
                        </g>
                    </g>
                </svg>
            </div>
            <slot name="logo-block"></slot>
        </div>
        <div v-show="isNavigationInitialized" class="nav-container d-flex">
            <div class="mainmenu w-100 p-0 m-0 menu-active accordion" id="accordionMenu">
                <div class="card" v-for="(category, index) in dataContainer1.categories">
                    <div class="card-header" :id="'heading'+index">
                        <a :href="getCategoryUrl(category)">{{ category.details[0].name }}</a>
                        <button v-if="category.children && category.children.length" class="btn btn-toggle collapsed" type="button" data-toggle="collapse" :data-target="'#menuCollapse'+index" aria-expanded="false" :aria-controls="'menuCollapse'+index">
                            <svg class="icon-plus" xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27">
                                <path id="Combined_Shape" data-name="Combined Shape" d="M12.15,27V14.85H0v-2.7H12.15V0h2.7V12.15H27v2.7H14.85V27Z" fill="#312527"/>
                            </svg>
                            <svg class="icon-minus" xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 3">
                                <rect id="Rectangle_7" data-name="Rectangle 7" width="3" height="27" transform="translate(0 3) rotate(-90)" fill="#312527"/>
                            </svg>
                        </button>
                    </div>

                    <div v-if="category.children && category.children.length" :id="'menuCollapse'+index" class="collapse position-relative" :aria-labelledby="'heading'+index" data-parent="#accordionMenu">
                        <div class="card-body">
                            <div class="triangle-down"></div>
                            <lazy-img v-if="menuData && menuData[index] && menuData[index].customImageBoxPath" class="pic-cover" picture-class="nav-image d-block full-abs"
                                :image-url="menuData[index].customImageBoxPath"
                                :alt="menuData[index].altText">
                            </lazy-img>
                            <div v-if="menuData && menuData[index] && menuData[index].customImageBoxPath" class="img-shadow"></div>
                            
                            <ul class="menu-children w-100 p-0 m-0" :class="{ 'c-image': menuData && menuData[index] && menuData[index].customImageBoxPath }">
                                <li class="" v-for="child in category.children">
                                    <a :href="getCategoryUrl(category,child)">{{ child.details[0].name }}</a>
                                    <ul class="sub-menu-children" v-if="child.children && child.children.length">
                                        <li v-for="subChild in child.children">
                                            <a :href="getCategoryUrl(category,child,subChild)">{{ subChild.details[0].name }}</a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="nav-footer d-flex">
            <client-only>
                <user-login-handler :small-style="true" :show-registration="false" :show-simple="true" @close-menu="closeNavigation()">
                    <a class="nav-link" data-toggle="modal" :aria-label="$translate('Ceres::Template.login')">
                        <i class="fa fa-user mr-0 mr-sm-1" aria-hidden="true"></i>
                        <span class="d-none d-sm-inline">{{ $translate("Ceres::Template.login") }}</span>
                    </a>
                </user-login-handler>
            </client-only>
        </div>

        <template v-if="!isNavigationInitialized">
            <ul class="breadcrumb">
                <li class="btn-close" @click="closeNavigation()"></li>

                <li class="breadcrumb-item">
                    <i class="fa fa-home" aria-hidden="true"></i>
                </li>
            </ul>

            <loading-animation></loading-animation>
        </template>
    </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";

export default {
    name: "mobile-navigation-heista",
    props: {
        template: {
            default: "#vue-mobile-navigation",
            type: String
        },
        includeLanguage: Boolean
    },
    jsonDataFields: [
        "menuData",
        "menuItems"
    ],

    data()
    {
        return {
            dataContainer1: {
                parent: {},
                categories: []
            },
            isNavigationInitialized: false,
            baseUrl: ""
        };
    },

    computed:
    {
        ...mapState({
            isMobileNavigationOpen: state => state.navigation.isMobileNavigationOpen
        })
    },

    created()
    {
        this.$store.commit("setCurrentCategory", null);
    },

    mounted()
    {
        this.initNavigation();
        console.log("menu Items");
        console.log(this.menuItems);
    },

    methods:
    {

        initNavigation()
        {
            if(this.menuItems) {
                this.dataContainer1.parent = null;
                this.dataContainer1.categories = this.menuItems;
                this.isNavigationInitialized = true;
            }
            
            console.log("init navigation");
            console.log(this.dataContainer1.categories);
        },

        closeNavigation()
        {
            this.$store.commit("setIsMobileNavigationOpen", false);
        },

        getCategoryUrl(cat, child1, child2)
        {
            const prefix = this.includeLanguage ? `/${App.language}` : "";

            let url = "";
            if(cat && cat.details[0] && cat.details[0].nameUrl) {
                url += "/" + cat.details[0].nameUrl;
            }
            if(child1 && child1.details[0] && child1.details[0].nameUrl) {
                url += "/" + child1.details[0].nameUrl;
            }
            if(child2 && child2.details[0] && child2.details[0].nameUrl) {
                url += "/" + child2.details[0].nameUrl;
            }
            
            return prefix + url;
        }
    }
}
</script>
